import { Skeleton } from '../ui';

export default function EditorSkeleton() {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden bg-slate-50">
      <div className="flex shrink-0 items-center justify-between border-b border-slate-200 bg-white px-5 py-3">
        <div className="space-y-2">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-5 w-40" />
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-9 w-20" />
          <Skeleton className="h-9 w-28" />
          <Skeleton className="h-9 w-24" />
        </div>
      </div>
      <div className="grid min-h-0 flex-1 grid-cols-[270px_minmax(0,1fr)_minmax(360px,430px)] gap-3 p-3">
        <div className="space-y-3 rounded-xl border border-slate-200 bg-slate-50 p-3">
          {(['sky', 'violet', 'amber', 'emerald'] as const).map((color) => (
            <div key={color} className={`flex items-center gap-2 rounded-xl border border-l-4 bg-white p-3 ${{ sky: 'border-sky-200 border-l-sky-400', violet: 'border-violet-200 border-l-violet-400', amber: 'border-amber-200 border-l-amber-400', emerald: 'border-emerald-200 border-l-emerald-400' }[color]}`}>
              <Skeleton className="h-3.5 w-3.5" />
              <div className="flex-1 space-y-1.5"><Skeleton className="h-3.5 w-28" /><Skeleton className="h-2.5 w-40 max-w-full" /></div>
            </div>
          ))}
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-4">
          <Skeleton className="h-5 w-32" />
          <div className="mt-6 space-y-3">
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton key={i} className="h-16 w-full" />
            ))}
          </div>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-4">
          <Skeleton className="h-5 w-40" />
          <div className="mt-6 space-y-3">
            {Array.from({ length: 8 }).map((_, i) => (
              <Skeleton key={i} className="h-8 w-full" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
